<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="bg-second-migas">
    <div class="container-fluid mt-cab-fixed">
        <div class="pre-content">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">Cert. Valorización Final</li>
                    <li class="breadcrumb-item" *ngIf="canViewResource('PO-ENV-GEST') || canViewResource('PO-ENV-CONS')">CVF</li>
                    <li class="breadcrumb-item" *ngIf="cvfTypeFromRoute === 'gestor'">CVF Gestor</li>
                    <li class="breadcrumb-item" *ngIf="cvfTypeFromRoute === 'poseedor'">CVF Poseedor</li>
                    <li class="breadcrumb-item active">Búsqueda de CVF</li>
                </ol>
            </nav>
            <div class="content-title">
                <h2 class="title-pag" *ngIf="canViewResource('PO-ENV-GEST') || canViewResource('PO-ENV-CONS')">Búsqueda de CVF</h2>
                <h2 class="title-pag" *ngIf="cvfTypeFromRoute === 'gestor'">Búsqueda de CVF Gestor</h2>
                <h2 class="title-pag" *ngIf="cvfTypeFromRoute === 'poseedor'">Búsqueda de CVF Poseedor</h2>
            </div>
        </div>
    </div>
</div>

<div class="container-form">
  <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
  <!-- Formulario de búsqueda -->
  <form *ngIf="mostrarFiltros" class="container-fluid form-search py-3" [formGroup]="generateForm">
        <div class="d-flex flex-wrap" style="gap: 1rem;">

            <div style="flex: 1 1 150px; max-width: 200px;">
                <label for="id">ID CVF</label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                    <input type="text" matInput formControlName="id" id="id" placeholder="ID CVF" (keydown)="onlyNumberKey($event)"
                        [min]="0">
                </mat-form-field>
            </div>

            <div style="flex: 1 1 150px; max-width: 200px;">
                <label for="anno">Año de los datos</label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                    <input type="number" matInput formControlName="anno" id="anno" placeholder="Año los datos" value=""
                        [min]="0">
                </mat-form-field>
            </div>

            <div style="flex: 1 1 200px; max-width: 300px;">
                <label for="estado">Estado CVF </label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                    <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple [compareWith]="compareEstado">
                        <mat-option *ngFor="let des of estadoArray" [value]="des">
                            {{ des.descripcion }}
                        </mat-option>
                    </mat-select>
                    <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                        (click)="clearSelection($event,'estado')">
                        <span aria-hidden="true" class="ng-clear">×</span>
                    </span>
                </mat-form-field>
            </div>

            <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
                <label for="tipoCvf">Tipo CVF </label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                    <mat-select formControlName="tipoCvf" id="tipoCvf" placeholder="-- Tipo CVF --">
                        <mat-option *ngFor="let tipo of tipoCvfArray" [value]="tipo.id">
                            {{ tipo.name }}
                        </mat-option>
                    </mat-select>
                    <span *ngIf="showClearButton('tipoCvf')" tabindex="0" class="ng-clear-wrapper"
                        (click)="clearSelection($event,'tipoCvf')">
                        <span aria-hidden="true" class="ng-clear">×</span>
                    </span>
                </mat-form-field>
            </div>

            <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="cvfTypeFromRoute !== 'poseedor'">
                <label for="idGestor">ID Gestor</label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                    <input type="text" matInput formControlName="idGestor" id="idGestor" placeholder="ID Gestor"  (keydown)="onlyNumberKey($event)"
                        value="">
                </mat-form-field>
            </div>

            <div style="flex: 1 1 200px; max-width: 300px;">
                <label for="nimaGestor">NIMA del Gestor </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input matInput formControlName="nimaGestor" id="nimaGestor" placeholder="NIMA del Gestor "
                            type="text">
                    </mat-form-field>
                </div>
            </div>

            <div style="flex: 1 1 300px; max-width: 400px;">
                <label for="razonSocialGestor">Razón Social Gestor </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input matInput formControlName="razonSocialGestor" id="razonSocialGestor"
                            placeholder="Razón Social Gestor" type="text">
                    </mat-form-field>
                </div>
            </div>

            <div style="flex: 1 1 180px; max-width: 250px;">
                <label for="documentoGestor">Documento Gestor (NIE, NIF) </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input matInput formControlName="documentoGestor" id="documentoGestor"
                            placeholder="Documento Gestor (NIE, NIF)" type="text">
                    </mat-form-field>
                </div>
            </div>

            <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')">
                    <label for="estadoGestor">Estado gestor </label>
                        <div class="custom-mat-field">
                           <mat-form-field class="custom-mat-form-field" appearance="outline">
                               <mat-select formControlName="estadoGestor" id="estadoGestor" placeholder="-- Estado Gestor --" multiple>
                                   <mat-option *ngFor="let des of estadosGestorArray" [value]="des.id">
                                          {{ des.descripcion }}
                                </mat-option>
                                </mat-select>
                                <span *ngIf="showClearButton('estadoGestor')" tabindex="0" class="ng-clear-wrapper"
                                (click)="clearSelection($event,'estadoGestor')">
                                <span aria-hidden="true" class="ng-clear">×</span>
                                </span>
                            </mat-form-field>
                        </div>
            </div>
            <div style="flex: 1 1 150px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS') || cvfTypeFromRoute === 'poseedor'">
                <label for="idPoseedor">ID Poseedor</label>
                <mat-form-field class="custom-mat-form-field" appearance="outline">
                    <input type="text" matInput formControlName="idPoseedor" id="idPoseedor" placeholder="ID Poseedor" (keydown)="onlyNumberKey($event)"
                        value="">
                </mat-form-field>
            </div>

            <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS') || cvfTypeFromRoute === 'poseedor'">
                <label for="nimaPoseedor">NIMA del Poseedor </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input matInput formControlName="nimaPoseedor" id="nimaPoseedor"
                            placeholder="NIMA del Poseedor " type="text">
                    </mat-form-field>
                </div>
            </div>

            <div style="flex: 1 1 300px; max-width: 400px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS') || cvfTypeFromRoute === 'poseedor'">
                <label for="razonSocialPoseedor">Razón Social Poseedor </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input matInput formControlName="razonSocialPoseedor" id="razonSocialPoseedor"
                            placeholder="Razón Social Poseedor" type="text">
                    </mat-form-field>
                </div>
            </div>

            <div style="flex: 1 1 180px; max-width: 250px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS') || cvfTypeFromRoute === 'poseedor'">
                <label for="documentoPoseedor">Documento Poseedor (NIE, NIF) </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <input matInput formControlName="documentoPoseedor" id="documentoPoseedor"
                            placeholder="Documento Poseedor (NIE, NIF)" type="text">
                    </mat-form-field>
                </div>
            </div>
            <div style="flex: 1 1 200px; max-width: 300px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
                <label for="estadoPoseedor">Estado poseedor </label>
                <div class="custom-mat-field">
                    <mat-form-field class="custom-mat-form-field" appearance="outline">
                        <mat-select formControlName="estadoPoseedor" id="estadoPoseedor" placeholder="-- Estado Poseedor --" multiple>
                            <mat-option *ngFor="let des of estadosPoseedorArray" [value]="des.id">
                                {{ des.descripcion }}
                            </mat-option>
                        </mat-select>
                        <span *ngIf="showClearButton('estadoPoseedor')" tabindex="0" class="ng-clear-wrapper"
                            (click)="clearSelection($event,'estadoPoseedor')">
                            <span aria-hidden="true" class="ng-clear">×</span>
                        </span>
                    </mat-form-field>
                </div>
            </div>
            <div style="flex: 1 1 100px; max-width: 150px;">
                <label for="reabierto">Rechazado</label>
                <div class="custom-mat-field mt-2 d-flex align-items-center">
                    <mat-checkbox color="primary" formControlName="reabierto" id="reabierto" class="blue-checkbox"></mat-checkbox>
                </div>
            </div>
            <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')" >
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')" >
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
              <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        </div>
    </form>

    <form class="container-fluid form-search py-3">
            <div class="button-group">
            <button type="button" class="btn btn-outline-primary" (click)="limpiar()">Limpiar</button>
            <button type="button" class="btn btn-primary" (click)="buscar()">Buscar</button>
        </div>
    </form>

</div>

<div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container-fluid">
        <div class="actions-table">
            <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
            <div class="text-right">
                <div class="d-inline">
                    <div class=" d-flex d-inline dropdown show" *ngIf="canViewResource('PO-ENV-GEST')">
                        <button type="button" 
                            class="btn btn-primary margin-bton-auto" data-toggle="modal"
                            (click)="crearAutoFactura()"><span class="icon-add"></span>Crear
                            Prefactura</button>

                            <a class="btn btn-outline-primary" role="button" aria-haspopup="true"
                            (click)="exportarExcel()" aria-expanded="false">
                            <span class="mr-3">Exportar</span></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-tabla-proy">
            <div class="card-body">
                <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
                    <div class="datatable-container table-responsive">
                        <!-- TABLA Listado con resultados de búsqueda -->
                        <lib-ge-table [headArray]="headArrayModificado" [gridArray]="gridArray" (checked)="checked($event)"
                            (actionButton)="action($event)"></lib-ge-table>
                        <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                            <div class="d-flex mt-2">
                                <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal"
                                    [(page)]="pageNumber" (pageChange)="renderPage($event)" [maxSize]="5"
                                    aria-label="Default pagination" size="sm">
                                </ngb-pagination>
                            </div>

                            <div class="mt-2 selectPage">
                                <label for="itemsPerPage">Mostrar:</label>
                                <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage"
                                    (change)="onItemsPerPageChange()">
                                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- FIN TABLA Listado con resultados de búsqueda -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #messageClear>
        <div class="mensaje-container">
            <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
                formulario.</p>
        </div>
    </ng-template>
</div>